// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7Oi0K","comment":"styles_comment__15_DF"};